import { keymap } from "prosemirror-keymap";
import { bindCommandToKey } from "../../commands/commands";
import { Extension } from "../../core/extension";
import { SlashCommandGroup, } from "../../core/types";
import { horizontalRuleNodeSpec } from "./schema";
export class HorizontalRuleExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(horizontalRuleNodeSpec());
    }
    addCommands() {
        return {
            addHorizontalRule: {
                active: () => false,
                enable: () => true,
                run: (state, dispatch) => {
                    const { tr, schema } = state;
                    dispatch(tr
                        .replaceSelectionWith(schema.nodes.horizontal_rule.create())
                        .scrollIntoView());
                },
            },
        };
    }
    addPlugins(schema, plugins, { commands }) {
        return plugins.concat([
            keymap({
                "Ctrl-_": bindCommandToKey(commands.addHorizontalRule),
            }),
        ]);
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Insert Divider Line`,
                description: `Insert a divider line to break document into sections`,
                group: SlashCommandGroup.Basics,
                icon: "is-divider-line",
                command: (match, view) => {
                    const { tr, schema } = view.state;
                    const { from, to } = match.range;
                    // use `from - 1` here since divider node creation is always triggered from inside a paragraph (from slash commands suggester)
                    // that way we remove the paragraph and replace it by the divider node if the match suggester is the only content
                    tr.replaceRangeWith(from - 1, to, schema.nodes.horizontal_rule.create());
                    view.dispatch(tr);
                },
            },
        ];
    }
}
